import { List, styled } from '@mui/material'

export const LinkList = styled(List, {
  name: 'LinkList',
})({
  width: '100%',
  padding: 0,
})
